import React from "react";
import RadialProgress from "../RadialProgress";
import StatusCircle from "../StatusCircle";

const ResultDial = ({
  size = 100,
  percentage = 0,
  status = "none",
  text = "",
}) => {
  function getSize(size) {
    switch (size) {
      case "large":
        return 96;
      case "medium":
        return 72;
      case "small":
        return 64;
      default:
        return 0;
    }
  }
  // Calculate internal dimensions based on total size
  const strokeWidth = getSize(size) * 0.12; // Relative thickness
  const innerCircleSize = getSize(size) * 0.65; // Inner circle is 65% of total size

  return (
    <div className={`si-result-dial-container si-size-${size}`}>
      <RadialProgress
        size={getSize(size)}
        strokeWidth={strokeWidth}
        percentage={percentage}
      />
      <StatusCircle size={innerCircleSize} status={status} text={text} />
    </div>
  );
};

export default ResultDial;
